angular.module('app').factory('NotifyService', function ($window, $location, $browser, $uibModal, moment, UserDetailsApi, // get the user from the cache if poss
$localStorage) {
    let fac = {
        switchOn: switchOn,
        switchOff: switchOff,
        isActive: isActive,
        incompatible: incompatible,
        authorize: authorize,
        show: show,
        newTraces: newTraces,
        newMessages: newMessages
    };
    let active = false;
    // Get the isActive status from local storage
    function init() {
        active = $localStorage.notifyIsActive || false;
    }
    init();
    function switchOn() {
        active = true;
        $localStorage.notifyIsActive = true;
    }
    function switchOff() {
        active = false;
        $localStorage.notifyIsActive = false;
    }
    function isActive() {
        return active;
    }
    function incompatible() {
        return typeof Notification === 'undefined';
    }
    function authorize() {
        Notification.requestPermission().then(function (result) {
            console.log(`Notify permissions ${result}`);
        });
    }
    /**
     * This is a general purpose notification
     */
    function show(body, title) {
        if (!active || incompatible()) {
            return;
        }
        authorize();
        let options = {
            body: body,
            icon: 'images/logo.png',
            tag: 'wtp'
        };
        title = `${title} @ ${timeString()}`;
        let n = new Notification(title, options);
        n.onclick = function () {
            console.log('show clicked');
            n.close();
        };
    }
    /**
 * Called when new traces arrive in trace summary/trace details
 */
    function newTraces(body) {
        if (!active || incompatible()) {
            return;
        }
        authorize();
        let options = {
            body: body,
            icon: 'images/logo.png',
            tag: 'wtp-traces'
        };
        let n = new Notification(`New Traces @ ${timeString()}`, options);
        n.onclick = function () {
            console.log('newTraces clicked');
            event.preventDefault(); // prevent the browser from focusing the Notification's tab
            UserDetailsApi.get().then(function (response) {
                let user = response.data;
                // $window.location.href = $browser.baseHref() + '#/TraceSummary';
                $location.url($browser.baseHref() + '#/TraceSummary');
                n.close();
            });
        };
    }
    /**
    * Called when new test notes arrive in nav bar
    */
    function newMessages(body) {
        if (!active || incompatible()) {
            return;
        }
        authorize();
        let options = {
            body: body,
            icon: 'images/logo.png',
            tag: 'wtp-trace-messages'
        };
        let n = new Notification(`New Messages @ ${timeString()}`, options);
        n.onclick = function () {
            console.log('newMessages clicked');
            event.preventDefault(); // prevent the browser from focusing the Notification's tab
            UserDetailsApi.get().then(function (response) {
                let user = response.data;
                // $window.location.href = $browser.baseHref() + '#/Messages';
                showNotes(user);
                n.close();
            });
        };
    }
    function timeString() {
        let m = moment();
        return moment().format('HH:mm');
    }
    /**
     * TODO: Create TestNotesModal.service
     * Create component test-notes-modal.component
     * Get the user from the UserDetailsApi service
     */
    function showNotes(connectedUser) {
        let modalInstance = $uibModal.open({
            animation: true,
            backdrop: 'static',
            templateUrl: 'scripts/app/partials/TestNotes/testNotes.tpl.html',
            controller: 'TestNotesController',
            controllerAs: 'vm',
            size: 'msg',
            windowClass: 'app-modal-window',
            resolve: {
                userDetails: function () {
                    return connectedUser;
                }
            }
        });
        modalInstance.result.then(function () {
            return;
        });
    }
    return fac;
});
